import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "../../../components/helpers/Spinner";
import ResponsiveModalAbsolute from "../../../components/ResponsiveModalAbsolute";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../../hooks/hooks";
import { number } from "yargs";

interface Props {
    setModalVisibleUsuario: (modalVisibleUsuario: boolean) => void;
    modalVisibleUsuario: boolean;
}

interface Interes {
    tipo_alquiler: string;
    tipo_inmueble: string;
}

interface INITAL_STATE_TYPE {
    [key: string]: string;
}

export const ModalCrearContacto = ({
    setModalVisibleUsuario,
    modalVisibleUsuario,
}: Props) => {
    const [userInfo, setUserInfo] = useState<INITAL_STATE_TYPE>({
        nombre: "",
        apellido: "",
        correo: "",
        celular: "",
    });

    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );

    const [putPresupuesto, setPutPresupuesto] = useState({
        presupuesto_inicio: 0,
        presupuesto_fin: 0,
        tipo_moneda_presupuesto: "PEN",
    });

    const [queryAlquiler, setqueryAlquiler] = useState({
        tipo_alquiler: "",
        tipo_inmueble: "",
    });

    const [intereses, setIntereses] = useState<Interes[]>([]);

    const INPUTS = [
        {
            input_id: 0,
            label: "Nombre",
            nombre: "nombre",
            type: "text",
        },
        {
            input_id: 1,
            label: "Apellido",
            nombre: "apellido",
            type: "text",
        },
        {
            input_id: 2,
            label: "Correo",
            nombre: "correo",
            type: "email",
        },
        {
            input_id: 3,
            label: "Celular",
            nombre: "celular",
            type: "text",
        },
    ];

    const [saving, setSaving] = useState<boolean>(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUserInfo({
            ...userInfo,
            [e.target.name]: e.target.value,
        });
    };

    const handleSave = async () => {
        const form = new FormData();
        if (userInfo.nombre.trim() === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                // position: "top-end",
                icon: "error",
                title: "debes agregar un nombre",

                showConfirmButton: true,
                // timer: 2000,
            });
            return;
        }
        if (userInfo.apellido.trim() === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                // position: "top-end",
                icon: "error",
                title: "debes agregar un apellido",

                showConfirmButton: true,
                // timer: 2000,
            });
            return;
        }
        if (userInfo.correo.trim() === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                // position: "top-end",
                icon: "error",
                title: "debes agregar un correo",

                showConfirmButton: true,
                // timer: 2000,
            });
            return;
        }
        if (userInfo.celular.trim() === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                // position: "top-end",
                icon: "error",
                title: "debes agregar un celular",

                showConfirmButton: true,
                // timer: 2000,
            });
            return;
        }

        setSaving(true);

        try {
            const data_usuario = await fetchAxiosToken({
                url: `/clientes/postContact`,
                method: "post",
                body: {
                    nombre: userInfo.nombre.trim(),
                    apellido: userInfo.apellido.trim(),
                    correo: userInfo.correo.trim(),
                    celular: userInfo.celular.trim(),
                    tipo_usuario:
                        tipo_usuario === 3
                            ? 5
                            : tipo_usuario === 6
                            ? 7
                            : tipo_usuario === 8
                            ? 9
                            : 5,
                },
            });

            await fetchAxiosToken({
                url: `/usuarios/updatePresupuesto/${data_usuario.usuario.id}`,
                method: "put",
                body: {
                    presupuesto_inicio: putPresupuesto.presupuesto_inicio,
                    presupuesto_final: putPresupuesto.presupuesto_fin,
                    tipo_moneda_presupuesto:
                        putPresupuesto.tipo_moneda_presupuesto,
                },
            });

            await fetchAxiosToken({
                url: `/usuario_intereses/createIntereses`,
                method: "post",
                body: {
                    intereses,
                    id_usuario: data_usuario.usuario.id,
                },
            });

            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                position: "top-end",
                icon: "success",
                title: "Contacto creado correctamente!",
                showConfirmButton: false,
                timer: 1500,
            });
            setModalVisibleUsuario(false);

            setSaving(false);
        } catch (error: any) {
            console.log(error);
            setSaving(false);

            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                // position: "top-end",
                icon: "error",
                title: `${error.response.data.error}`,
                showConfirmButton: true,
                // timer: 1500,
            });
        }
    };

    const handleAgregarInteres = () => {
        const { tipo_alquiler, tipo_inmueble } = queryAlquiler;

        if (!tipo_alquiler || !tipo_inmueble) {
            alert("Debe seleccionar tipo de alquiler e inmueble.");
            return;
        }

        const nuevoInteres: Interes = {
            tipo_alquiler,
            tipo_inmueble,
        };

        setIntereses((prev) => [...prev, nuevoInteres]);

        // Opcional: resetear selección
        setqueryAlquiler({
            tipo_alquiler: "",
            tipo_inmueble: "",
        });
    };

    const handleEliminarInteres = (index: number) => {
        setIntereses((prev) => prev.filter((_, i) => i !== index));
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisibleUsuario}
            setModalVisible={setModalVisibleUsuario}
        >
            <div className="flex flex-col items-center max-w-lg gap-4 p-4 mx-auto ">
                <h2 className="text-base font-medium">Crear Contacto</h2>
                <hr className="w-full bg-gray-300" />

                <div className="flex flex-col items-center w-full px-6">
                    {INPUTS.map(({ nombre, input_id, type, label }) => (
                        <div key={input_id} className="w-full max-w-xl">
                            <label className="font-medium 2xl:text-base text-sm">
                                {label}
                            </label>
                            <input
                                className="w-full 2xl:p-2 p-1.5 mt-1 border rounded-xl"
                                placeholder={label}
                                name={nombre}
                                value={userInfo[nombre]}
                                onChange={handleInputChange}
                                type={type}
                            />
                        </div>
                    ))}
                </div>
                {tipo_usuario === 6 && (
                    <div className="w-full max-w-xl mt-6">
                        <label className="font-medium 2xl:text-base text-sm block mb-1">
                            Presupuesto
                        </label>
                        <hr className="w-full border-2 bg-gray-700 mb-4" />

                        <div className="flex flex-col md:flex-row gap-4">
                            <input
                                type="number"
                                name="presupuesto_inicio"
                                value={putPresupuesto.presupuesto_inicio}
                                onChange={(e) =>
                                    setPutPresupuesto((prev) => ({
                                        ...prev,
                                        presupuesto_inicio: Number(
                                            e.target.value
                                        ),
                                    }))
                                }
                                placeholder="Desde"
                                className="w-full p-2 border rounded-xl px-5"
                            />
                            <input
                                type="number"
                                name="presupuesto_fin"
                                value={putPresupuesto.presupuesto_fin}
                                onChange={(e) =>
                                    setPutPresupuesto((prev) => ({
                                        ...prev,
                                        presupuesto_fin: Number(e.target.value),
                                    }))
                                }
                                placeholder="Hasta"
                                className="w-full p-2 border rounded-xl px-5"
                            />
                        </div>

                        <div className="mt-4">
                            <label className="block text-sm font-medium mb-1">
                                Tipo de moneda
                            </label>
                            <select
                                name="tipo_moneda_presupuesto"
                                value={putPresupuesto.tipo_moneda_presupuesto}
                                onChange={(e) =>
                                    setPutPresupuesto((prev) => ({
                                        ...prev,
                                        tipo_moneda_presupuesto: e.target.value,
                                    }))
                                }
                                className="w-full p-2 border rounded-xl bg-white px-5"
                            >
                                <option value="PEN">PEN - Soles</option>
                                <option value="USD">USD - Dólares</option>
                            </select>
                        </div>
                    </div>
                )}

                {tipo_usuario === 6 && (
                    <div className="w-full max-w-xl mt-6">
                        <label className="font-medium 2xl:text-base text-sm block mb-1">
                            Intereses
                        </label>
                        <hr className="w-full border-2 bg-gray-700 mb-4" />

                        <div className="flex justify-center items-center gap-4 w-full ">
                            <div className=" w-5/12 ">
                                <label className="block text-sm font-medium mb-1">
                                    Tipo de alquiler
                                </label>
                                <select
                                    name="tipo_alquiler"
                                    value={queryAlquiler.tipo_alquiler}
                                    onChange={(e) =>
                                        setqueryAlquiler((prev) => ({
                                            ...prev,
                                            tipo_alquiler: e.target.value,
                                            tipo_inmueble: "", // reseteamos selección
                                        }))
                                    }
                                    className="w-full p-2 border rounded-xl bg-white px-5"
                                >
                                    <option value="">
                                        Selecciona una opción
                                    </option>
                                    <option value="alquiler vacacional">
                                        Alquiler vacacional
                                    </option>
                                    <option value="alquiler">Alquiler</option>
                                    <option value="venta">Venta</option>
                                </select>
                            </div>

                            {/* Tipo de inmueble */}
                            <div className=" w-5/12 ">
                                <label className="block text-sm font-medium mb-1">
                                    Tipo de inmueble
                                </label>
                                <select
                                    name="tipo_inmueble"
                                    value={queryAlquiler.tipo_inmueble}
                                    onChange={(e) =>
                                        setqueryAlquiler((prev) => ({
                                            ...prev,
                                            tipo_inmueble: e.target.value,
                                        }))
                                    }
                                    className="w-full p-2 border rounded-xl bg-white px-5"
                                >
                                    <option value="">
                                        Selecciona una opción
                                    </option>
                                    {queryAlquiler.tipo_alquiler ===
                                    "alquiler vacacional" ? (
                                        <>
                                            <option value="casa">Casa</option>
                                            <option value="departamento">
                                                Departamento
                                            </option>
                                        </>
                                    ) : (
                                        <>
                                            <option value="casa">Casa</option>
                                            <option value="departamento">
                                                Departamento
                                            </option>
                                            <option value="terreno">
                                                Terreno
                                            </option>
                                            <option value="oficina">
                                                Oficina
                                            </option>
                                            <option value="local comercial">
                                                Local Comercial
                                            </option>
                                        </>
                                    )}
                                </select>
                            </div>
                            <div className="w-2/12 mt-5">
                                <div
                                    onClick={handleAgregarInteres}
                                    className="p-1 w-8 flex justify-center items-center text-bold text-2xl text-white bg-blue-500 rounded-lg cursor-pointer hover:scale-105 h-8  text-center"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        className="h-6 w-6"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M12 4.5v15m7.5-7.5h-15"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {intereses.length > 0 && (
                    <div className="mt-6 w-full ">
                        <h3 className="font-semibold text-base mb-2">
                            Intereses agregados:
                        </h3>
                        <div className="w-full text-base">
                            {intereses.map((item, index) => (
                                <div
                                    className="flex justify-between items-center border-b border-gray-300 p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
                                    key={index}
                                >
                                    {item.tipo_alquiler} - {item.tipo_inmueble}
                                    <div
                                        onClick={() =>
                                            handleEliminarInteres(index)
                                        }
                                        className="text-blue-500 cursor-pointer border border-blue-500 rounded-lg p-1 hover:bg-blue-500 hover:text-white"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="w-5 h-5"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="flex flex-col gap-4 2xl:mt-8 mt-4">
                    {saving ? (
                        <Spinner />
                    ) : (
                        <button
                            onClick={() => handleSave()}
                            className="p-3 px-5 text-white border rounded-lg 2xl:text-base text-sm bg-[#1C4CBB] hover:scale-105"
                        >
                            Crear contacto
                        </button>
                    )}
                </div>
            </div>
        </ResponsiveModalAbsolute>
    );
};
